const BACKEND_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

/**
 * Returns the full URL for a given image path
 * @param {string} imagePath - The stored image path (e.g., "/uploads/products/8/image.png")
 * @returns {string} - Full image URL
 */
export const getImageUrl = (imagePath) => {
    return imagePath.startsWith("http") ? imagePath : `${BACKEND_URL}${imagePath}`;
};